function sendGA(val) {
  if (typeof ga !== "undefined" && !(val.medium == "" && val.source == "")) {
    ga("gtm1.send", "event", val.medium, "説明会/体験会登録", val.source);
    return true;
  }
  return false;
}

$(function () {
  if ($(".thanks #affiliates").length < 1) return;

  var values = {
    source: $("#source").text(),
    medium: $("#medium").text(),
  };

  if (!sendGA(values)) {
    setTimeout(function () {
      sendGA(values);
    }, 1200);
  }
});
